import React from 'react';
import { arrayOf, bool, func, number, object, string } from 'prop-types';
import clsx from 'clsx';
import { CustomPaging, PagingState } from '@devexpress/dx-react-grid';
import {
    Grid,
    Table,
    TableHeaderRow,
    VirtualTable
} from '@devexpress/dx-react-grid-material-ui';
import moment from 'moment';

import ScoringTableCellRenderer from './ScoringTableCellRenderer';
import MetaContext from '../../components/RuleExceptionsTable/MetaContext';
import NoDataCell from '../../components/RuleExceptionsTable/NoDataCell';
import ProgressBar from '../../components/ProgressBar';

import defaultClasses from '../../components/RuleExceptionsTable/RuleExceptionsTable.module.css';
import { getTimeZoneAbbr } from '../../helpers/timezones';


const COLUMNS = [
    {
        getCellValue(row) {
            if (!row.insertTimestamp) {
                return;
            }
            const zone = moment.tz.guess();
            return moment.parseZone(row.insertTimestamp).local().format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(row.insertTimestamp, zone);
        },
        name:  'insertTimestamp',
        title: 'Timestamp'
    },
    { name: 'id', title: 'Target' },
    {
        name:  'message',
        title: 'Error Message'
    },
    { name: 'action', title: 'Action' }
];

const StyledTable = (props) => (
    <Table.Table {...props} className={defaultClasses.table} />
);

const StyledHeaderCellComponent = (props) => (
    <TableHeaderRow.Cell
        {...props}
        className={clsx(defaultClasses.cell, defaultClasses.headerCell)}
    />
);

const TableColumnExtensions = [
    { columnName: 'insertTimestamp', width: 250 },
    { columnName: 'target', width: 300 }
];

const ScoreDebuggerTable = ({
    currentPage,
    error,
    scoringLogs,
    isLoading,
    onCurrentPageChange,
    onPageSizeChange,
    pageSize,
    totalCount
}) => {
    let scoringDataMessage = 'There is no Scoring Data in this time period';
    if (isLoading) {
        scoringDataMessage = 'Loading Scoring Data...';
    } else if (error) {
        scoringDataMessage = `Error Loading Scoring Data: ${error}`;
    }

    return (
        <MetaContext.Provider value={{ error }}>
            <ProgressBar
                className={defaultClasses.progressBar}
                hidden={!isLoading}
            />
            <Grid columns={COLUMNS} rows={scoringLogs}>
                <PagingState
                    currentPage={currentPage}
                    onCurrentPageChange={onCurrentPageChange}
                    onPageSizeChange={onPageSizeChange}
                    pageSize={pageSize}
                />
                <CustomPaging totalCount={totalCount} />
                <VirtualTable
                    cellComponent={ScoringTableCellRenderer}
                    columnExtensions={TableColumnExtensions}
                    messages={{
                        noData: scoringDataMessage
                    }}
                    noDataCellComponent={NoDataCell}
                    tableComponent={StyledTable}
                />
                <TableHeaderRow cellComponent={StyledHeaderCellComponent} />
            </Grid>
        </MetaContext.Provider>
    );
};

ScoreDebuggerTable.defaultProps = {
    scoringLogs:         [],
    isLoading:           false,
    onCurrentPageChange: () => {},
    onPageSizeChange:    () => {}
};

ScoreDebuggerTable.propTypes = {
    currentPage:         number,
    error:               string,
    scoringLogs:         arrayOf(object),
    isLoading:           bool,
    onCurrentPageChange: func,
    onPageSizeChange:    func,
    pageSize:            number,
    totalCount:          number
};

export default ScoreDebuggerTable;
